/* eslint-disable */
import { Popconfirm } from 'components/atoms/popconfirm';
import { Button } from 'components/atoms/button';
import TrashCan16 from '@carbon/icons-react/es/trash-can/16';
import Save16 from '@carbon/icons-react/es/save/16';
import React, { FC } from 'react';
import { Divider } from 'antd';

export const DemoPopconfirmPage: FC = () => (
  <>
    <h3>Popconfirm</h3>
    <h6>Default delete confirmation</h6>
    <Popconfirm
      onConfirm={() => {
        alert('Confirm button clicked');
      }}
    >
      <Button icon={<TrashCan16 />} type="ghost" size="small" danger />
    </Popconfirm>
    <Divider />
    <h6>Default confirmation popup</h6>
    <Popconfirm
      danger={false}
      title="Save"
      subTitle="Are you sure want to save the page?"
      onConfirm={() => {
        alert('Confirm button clicked');
      }}
    >
      <Button icon={<Save16 />} size="small" />
    </Popconfirm>
  </>
);
